export const pkg = {
  name: 'isomorphic-git',
  version: '1.40.0',
  agent: 'git/isomorphic-git@1.40.0',
}
